import Vue from 'vue'
import http from '@/utils/ajax'
import { MISC_INIT_LOADING, MISC_INIT_SUCCESS, MISC_INIT_FAIL, MISC_ISOCTYLIST, MISC_DURATION_INIT_LOADING, MISC_DURATION_INIT_SUCCESS, MISC_DURATION_INIT_FAIL, MISC_DURATION_LIST } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  isoCtyList: [],
  durationList: []
}

const getters = {

}

const mutations = {
  [MISC_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [MISC_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [MISC_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [MISC_ISOCTYLIST](state, data) {
    Vue.set(state, 'isoCtyList', data)
  },
  [MISC_DURATION_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [MISC_DURATION_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [MISC_DURATION_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [MISC_DURATION_LIST](state, data) {
    Vue.set(state, 'durationList', data)
  }
}

const actions = {
  async miscInit({ commit, rootState }) {
    const apiUrl = rootState.parameters.menu.isoCtyList
    commit(MISC_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }

      let apiURL = commitResult.menu.getISOCtys
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          const { data } = result.data
          commit(MISC_ISOCTYLIST, data)
        } catch (err) {
          throw err
        }
      }

      commit(MISC_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(MISC_INIT_FAIL, extractMessages(error))
    }
  },
  async miscDuration({ commit, rootState }) {
    const apiUrl = rootState.parameters.menu.durationList
    commit(MISC_DURATION_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }

      let apiURL = commitResult.menu.getDurations
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          const { data } = result.data
          commit(MISC_DURATION_LIST, data)
        } catch (err) {
          throw err
        }
      }

      commit(MISC_DURATION_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(MISC_DURATION_INIT_FAIL, extractMessages(error))
    }
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
